import React from 'react';
import { Box, Typography, IconButton, Paper } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { documentCardSx, terminalColors, terminalBarIconButtonSx } from '../../theme/terminalStyles';
import { formatMoney } from '../../helpers/dataFormatter';

const SALE_CARD_ACTION_SIZE = 36;
const SALE_CARD_STATUS_DOT_SIZE = 24;

const SaleDocumentCard = ({ sale, statusColor, pickingStatus, onStart }) => {
  const dateStr = sale.date ? new Date(sale.date).toLocaleDateString('uk-UA') : '—';
  const sp = [...(sale.spickings || [])].sort((a, b) => a.id - b.id)[0];
  const isFullyCollected = Boolean(sale.isCollected || sp?.isDone);

  return (
    <Paper sx={documentCardSx} elevation={0}>
      <Box sx={{ display: 'flex', alignItems: 'stretch', gap: 1.5 }}>
        <Box
          sx={{
            width: SALE_CARD_ACTION_SIZE,
            minWidth: SALE_CARD_ACTION_SIZE,
            flexShrink: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
            py: 0.25,
          }}
        >
          <IconButton
            onClick={onStart}
            aria-label="Почати збірку"
            sx={{
              ...terminalBarIconButtonSx,
              width: SALE_CARD_ACTION_SIZE,
              height: SALE_CARD_ACTION_SIZE,
              minWidth: SALE_CARD_ACTION_SIZE,
              minHeight: SALE_CARD_ACTION_SIZE,
            }}
          >
            {isFullyCollected ? <LockOutlinedIcon /> : <PlayArrowIcon />}
          </IconButton>
          <Box
            aria-hidden
            sx={{
              width: SALE_CARD_STATUS_DOT_SIZE,
              height: SALE_CARD_STATUS_DOT_SIZE,
              borderRadius: '50%',
              bgcolor: statusColor,
              flexShrink: 0,
              ...(pickingStatus === 'resume'
                ? { border: '1px solid rgba(0, 0, 0, 0.12)' }
                : {}),
            }}
          />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="subtitle1" fontWeight={700} noWrap>
            № {sale.number}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {dateStr}
          </Typography>
          <Typography variant="body2" sx={{ mt: 0.5 }} noWrap title={sale.clientName}>
            {sale.clientName || '—'}
          </Typography>
          <Box
            sx={{
              mt: 1,
              display: 'flex',
              alignItems: 'baseline',
              gap: 2,
              minWidth: 0,
            }}
          >
            <Typography variant="body1" fontWeight={600} sx={{ flexShrink: 0 }}>
              {formatMoney(sale.sum ?? 0)} ₴
            </Typography>
            {sale.ttnNumber ? (
              <Typography
                variant="body2"
                color="text.secondary"
                noWrap
                title={`ТТН: ${sale.ttnNumber}`}
                sx={{ minWidth: 0, flex: 1 }}
              >
                ТТН: {sale.ttnNumber}
              </Typography>
            ) : null}
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};

export default SaleDocumentCard;
